import ConfirmInstalledModal from './confirm-installed-modal.vue'
export default ConfirmInstalledModal
